import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type {
  ApiResponse,
  RequestPasswordResetData,
  VerifyCodeData,
  ResetPasswordData,
} from "@membentry/shared-types";
import {
  requestPasswordReset,
  verifyPasswordResetCode,
  resetPassword,
} from "@membentry/shared-api";

export const PASSWORD_RESET_QUERY_KEY = "password-reset";

export function useRequestPasswordResetMutation(
  client: AxiosInstance,
  options?: Omit<
    UseMutationOptions<ApiResponse<unknown>, Error, RequestPasswordResetData>,
    "mutationFn"
  >,
) {
  return useMutation({
    mutationFn: (data: RequestPasswordResetData) =>
      requestPasswordReset(client, data),
    ...options,
  });
}

export function useVerifyCodeMutation(
  client: AxiosInstance,
  options?: Omit<
    UseMutationOptions<ApiResponse<{ token: string }>, Error, VerifyCodeData>,
    "mutationFn"
  >,
) {
  return useMutation({
    mutationFn: (data: VerifyCodeData) =>
      verifyPasswordResetCode(client, data),
    ...options,
  });
}

export function useResetPasswordMutation(
  client: AxiosInstance,
  options?: Omit<
    UseMutationOptions<ApiResponse<unknown>, Error, ResetPasswordData>,
    "mutationFn"
  >,
) {
  return useMutation({
    mutationFn: (data: ResetPasswordData) => resetPassword(client, data),
    ...options,
  });
}
